import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { environment } from 'environments/environment';
import { Module } from '@common/models';

@Injectable({ providedIn: 'root' })
export class ModuleService {
  /**
   *
   * @param {HttpClient} _http
   */
  constructor(private _http: HttpClient) {}

  /**
   * Get all modules
   */
  getAll() {
    return this._http.get<Module[]>(`${environment.commonApiUrl}/api/modules`);
  }

  /**
   * Get module by id
   */
  getById(id: number) {
    return this._http.get<Module>(`${environment.commonApiUrl}/api/modules/${id}`);
  }

  addModule(module){
    return this._http.post<Module>(`${environment.commonApiUrl}/api/modules`, module).pipe(
      map((response: any) => response.module as Module),
      catchError(e => {
        return throwError(e);
      })
    );
  }

  editModule(module){
    return this._http.put<Module>(`${environment.commonApiUrl}/api/modules/${module.id}`, module).pipe(
      map((response: any) => response.module as Module),
      catchError(e => {
        return throwError(e);
      })
    );
  }

  changeStatus(id: number, status: string) {
    return this._http.put<Module>(`${environment.commonApiUrl}/api/modules/${id}/${status}`,{}).pipe(
      map((response: any) => response.module as Module),
      catchError(e => {
        return throwError(e);
      })
    );
  }
  
}
